<template>
  <div class="about-us-page">
    <main-header />

    <!-- Hero Section -->
    <section class="hero-section">
      <div class="container">
        <h1 class="hero-title">About Us</h1>
        <p class="hero-subtitle">
          We created My Oxytocin to solve a simple problem: in a world overflowing 
          with generic gifts, it's hard to find something truly personal.
        </p>
        <div class="hero-images">
          <div class="hero-image">
            <img src="/assets/images/About Us Page/1.jpeg" alt="Pet and owner 1" />
          </div>
          <div class="hero-image">
            <img src="/assets/images/About Us Page/2.jpeg" alt="Pet and owner 2" />
          </div>
          <div class="hero-image">
            <img src="/assets/images/About Us Page/3.jpeg" alt="Pet and owner 3" />
          </div>
          <div class="hero-image">
            <img src="/assets/images/About Us Page/4.jpeg" alt="Pet and owner 4" />
          </div>
        </div>
      </div>
    </section>

    <!-- Our Solution Section -->
    <section class="solution-section">
      <div class="container">
        <div class="solution-content">
          <div class="solution-text">
            <h2>Our Solution</h2>
            <p>
              Personalized pet-themed gift boxes that celebrate the bond between 
              humans and their animal companions.
            </p>
          </div>
          <div class="solution-image">
            <img src="/assets/images/About Us Page/DSCF2382.jpg" alt="Our products" />
          </div>
        </div>
      </div>
    </section>

    <!-- What Makes Us Different Section -->
    <section class="difference-section">
      <div class="container">
        <h2 class="section-title">What Makes Us Different?</h2>
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon">
              <img src="/assets/images/About Us Page/art 1.png" alt="Artsy & Premium" />
            </div>
            <h3>Artsy & Premium</h3>
            <p>Designed with creativity and care</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <img src="/assets/images/About Us Page/helping 1.png" alt="Empathetic" />
            </div>
            <h3>Empathetic</h3>
            <p>Built to celebrate love, memories, and companionship</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <img src="/assets/images/About Us Page/review 1.png" alt="Convenient" />
            </div>
            <h3>Convenient</h3>
            <p>Personalization is as easy as sharing a pet's social handle</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Quote Section -->
    <section class="quote-section">
      <div class="container">
        <h2 class="quote-text">
          GIFTING SHOULD BE MEANINGFUL, FUN, AND EFFORTLESS.
        </h2>
      </div>
    </section>

    <!-- Why My Oxytocin Section -->
    <section class="why-section">
      <div class="why-content">
        <div class="why-text">
          <h2>Why "My Oxytocin"?</h2>
          <p>
            Oxytocin is often called the <strong>love hormone</strong>. 
            It's the chemical that helps create bonds of affection—between partners, 
            families, and yes, between humans and their pets.
          </p>
          <p>
            Our name, My Oxytocin, reflects that feeling: 
            <strong>"You are my oxytocin—you make me feel loved."</strong> 
            We aim to capture that emotion in every gift box, enhancing the love 
            people share with their furry (or not-so-furry) friends.
          </p>
        </div>
        <div class="why-visual">
          <h3 class="oxytocin-text">
            YOU<br>
            ARE<br>
            MY<br>
            OXY-<br>
            TOCIN
          </h3>
          <p class="side-text">
            More than a box --<br><br>
            a My Oxytocin gift is joy, thoughtfulness, and love.
          </p>
        </div>
      </div>
    </section>

    <!-- When You Choose Section -->
    <section class="choose-section">
      <div class="container">
        <h2>When you choose My Oxytocin,</h2>
        <h3>you're choosing:</h3>
        <div class="choose-grid">
          <div class="choose-card">
            <div class="choose-image">
              <img src="/assets/images/About Us Page/group 24.png" alt="Thoughtful gift" />
            </div>
          </div>
          <div class="choose-card">
            <div class="choose-image">
              <img src="/assets/images/About Us Page/group 25.png" alt="Thoughtful gift" />
            </div>
          </div>
          <div class="choose-card">
            <div class="choose-image">
              <img src="/assets/images/About Us Page/group 26.png" alt="Meaningful celebration" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Meet Our Team Section -->
    <!-- <section class="team-section">
      <div class="container">
        <h2 class="section-title">Meet Our Team</h2>
        <div class="team-grid">
          <div class="team-member" v-for="member in teamMembers" :key="member.id">
            <div class="member-avatar">
              <img :src="member.avatar" :alt="member.name" />
            </div>
            <h4>{{ member.name }}</h4>
            <p>{{ member.role }}</p>
          </div>
        </div>
      </div>
    </section> -->

    <!-- Our Vision Section -->
    <section class="vision-section">
      <div class="vision-content">
        <div class="vision-image">
          <img src="/assets/images/About Us Page/Intersect.png" alt="Our Vision" />
        </div>
        <div class="vision-text">
          <span class="eyebrow">LAST BUT NOT THE LEAST</span>
          <h2>Our Vision</h2>
          <p>
            We want to put the joy back into gifting.
          </p>
          <p>
            Each of our products is designed to make people feel loved, connected, 
            and understood—whether it's a pet portrait to honor a cherished companion, 
            or a playful daily-use item that keeps memories alive.
          </p>
        </div>
      </div>
    </section>

    <main-footer />
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';
import MainFooter from '@/components/MainFooter.vue';

export default {
  name: 'ContactView',
  components: {
    MainHeader,
    MainFooter
  },
  data() {
    return {
      teamMembers: [
        { id: 1, name: 'Angel Lok', role: 'Founder', avatar: '/assets/images/compressed/Human1.png' },
        { id: 2, name: 'Ka Ho Leung', role: 'Frontend builder', avatar: '/assets/images/compressed/Human2.png' },
        { id: 3, name: 'San Sing Lee', role: 'Backend builder', avatar: '/assets/images/compressed/Human3.png' },
      ]
    };
  }
};
</script>

<style scoped>
.about-us-page {
  background-color: #fffef9;
  min-height: 100vh;
}

.container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 60px;
}

/* Hero Section */
.hero-section {
  background-color: #ffeee5;
  padding: 100px 0 60px;
  text-align: center;
}

.hero-title {
  font-family: 'Jost', sans-serif;
  font-size: 35px;
  font-weight: 600;
  color: #e37267;
  margin-bottom: 30px;
}

.hero-subtitle {
  font-family: 'Jost', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: rgba(168, 98, 91, 0.9);
  max-width: 413px;
  margin: 0 auto 40px;
  line-height: 1.5;
}

.hero-images {
  display: flex;
  gap: 30px;
  justify-content: center;
  margin-top: 40px;
}

.hero-image {
  width: 201px;
  height: 184px;
  border-radius: 10px;
  overflow: hidden;
}

.hero-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Solution Section */
.solution-section {
  padding: 60px 0;
  background: #fffef9;
}

.solution-content {
  display: flex;
  align-items: center;
  gap: 100px;
}

.solution-text {
  flex: 0 0 300px;
}

.solution-text h2 {
  font-family: 'Jost', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #e37267;
  margin-bottom: 20px;
}

.solution-text p {
  font-family: 'Jost', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #989898;
  line-height: 1.5;
}

.solution-image {
  flex: 1;
  text-align: right;
  height: 360px;
  overflow: hidden;
  display: flex;
  justify-content: flex-end; /* 保持图片靠右对齐（因 text-align: right） */
  align-items: center;       /* 垂直居中关键 */
}

.solution-image img {
  height: 100%;              /* 占满容器高度 */
  width: auto;               /* 保持原始宽高比 */
  object-fit: cover;         /* 裁剪以填满容器 */
  object-position: center;   /* 图片内容居中（水平+垂直） */
  min-width: 100%;           /* 确保宽高比下能覆盖容器（可选） */
}

/* Difference Section */
.difference-section {
  padding: 80px 0;
  background: #fffef9;
}

.section-title {
  font-family: 'Jost', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #e37267;
  text-align: center;
  margin-bottom: 60px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 60px;
  max-width: 900px;
  margin: 0 auto;
}

.feature-card {
  text-align: center;
}

.feature-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
  background: #ffe1cf;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* filter: blur(5px); */
}
.feature-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.feature-card h3 {
  font-family: 'Jost', sans-serif;
  font-size: 14px;
  font-weight: 800;
  color: #000;
  margin-bottom: 15px;
}

.feature-card p {
  font-family: 'Jost', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #989898;
  line-height: 1.5;
  max-width: 145px;
  margin: 0 auto;
}

/* Quote Section */
.quote-section {
  padding: 80px 0;
  background: #fffef9;
}

.quote-text {
  font-family: 'Eczar', serif;
  font-size: 48px;
  font-weight: 500;
  color: #e37267;
  text-align: center;
  text-transform: uppercase;
  line-height: 1.1;
  max-width: 495px;
  margin: 0 auto;
}

/* Why Section */
.why-section {

  padding: 80px 60px;
  position: relative;
}

.why-content {
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  gap: 100px;
  align-items: center;
}

.why-text {
  flex: 0 0 550px;
  margin-right: -30px;
  background: #ffeee5;
  padding: 30px;
  transform: scale(1.5);
  margin-left: 70px;
}

.why-text h2 {
  font-family: 'Jost', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #e37267;
  margin-bottom: 30px;
}

.why-text p {
  font-family: 'Jost', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #7e7e7e;
  line-height: 1.5;
  margin-bottom: 20px;
}

.why-text strong {
  font-weight: 700;
  color: rgba(168, 98, 91, 0.9);
}

.why-visual {
  flex: 1;
  position: relative;
  text-align: right;
}

.oxytocin-text {
  font-family: 'Khand', sans-serif;
  font-size: 95px;
  font-weight: 700;
  color: #ffeee5;
  text-transform: uppercase;
  line-height: 0.87;
  text-align: left;
  margin-left: 40px;
}

.side-text {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-family: 'Jost', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #e37267;
  text-transform: uppercase;
  text-align: right;
  line-height: 1.3;
}

/* Choose Section */
.choose-section {
  padding: 80px 0;
  background: #fffef9;
}

.choose-section h2 {
  font-family: 'Jost', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #000;
  text-align: center;
  margin-bottom: 10px;
}

.choose-section h3 {
  font-family: 'Jost', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #e37267;
  text-align: center;
  margin-bottom: 50px;
}

.choose-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 50px;
  max-width: 900px;
  margin: 0 auto;
}

.choose-card {
  position: relative;
  text-align: center;
}

.choose-image {
  width: 253px;
  height: 645px;
  margin: 0 auto 20px;
  /* overflow: hidden; */
  border-radius: 10px;
}

.choose-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.choose-number {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  font-family: 'Eczar', serif;
  font-size: 200px;
  font-weight: 500;
  color: #fffef9;
  line-height: 1;
  z-index: 1;
}

.choose-card p {
  font-family: 'Jost', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  line-height: 1.3;
  position: relative;
  z-index: 2;
  background: #ffeee5;
  padding: 20px;
  margin: -40px 0 0;
}

/* Team Section */
.team-section {
  padding: 80px 0;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 30px;
  /* overflow-x: auto; */
}

.team-member {
  text-align: center;
  min-width: 150px;
}

.member-avatar {
  width: 150px;
  height: 250px;
  margin: 0 auto 15px;
  overflow: hidden;
}

.member-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.team-member h4 {
  font-family: 'Jost', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #000;
  margin-bottom: 5px;
}

.team-member p {
  font-family: 'Jost', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #e37267;
}

/* Vision Section */
.vision-section {
  background: #ffeee5;
  padding: 80px 0;
}

.vision-content {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 60px;
  display: flex;
  align-items: center;
  gap: 80px;
}

.vision-image {
  flex: 0 0 400px;
  transform: scale(1.52) translateX(-120px);
}

.vision-image img {
  width: 100%;
  height: auto;
}

.vision-text {
  flex: 1;
}

.eyebrow {
  font-family: 'Jost', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #000;
  text-transform: uppercase;
  display: block;
  margin-bottom: 15px;
}

.vision-text h2 {
  font-family: 'Jost', sans-serif;
  font-size: 32px;
  font-weight: 500;
  color: #e37267;
  text-transform: uppercase;
  margin-bottom: 30px;
}

.vision-text p {
  font-family: 'Jost', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #7e7e7e;
  line-height: 1.5;
  margin-bottom: 15px;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .container {
    padding: 0 30px;
  }

  .hero-images {
    flex-wrap: wrap;
    gap: 20px;
  }

  .hero-image {
    width: calc(50% - 10px);
  }

  .solution-content {
    flex-direction: column;
    gap: 40px;
  }

  /* Make solution image area adaptive on tablets: show full image centered */
  .solution-image {
    height: auto;
    justify-content: center;
    text-align: center;
  }

  .solution-image img {
    width: 100%;
    height: auto;
    min-width: 0;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }

  /* Choose images on tablets: show full image */
  .choose-image {
    width: 100%;
    height: auto;
    text-align: center;
  }

  .choose-image img {
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .why-content {
    flex-direction: column;
    gap: 50px;
  }

  .why-text {
    flex: 1;
    transform: none;
    margin-left: 0;
    margin-right: 0;
  }

  .oxytocin-text {
    font-size: 60px;
    margin-left: 0;
    text-align: center;
  }

  .side-text {
    position: static;
    transform: none;
    text-align: center;
    margin-top: 30px;
  }

  .choose-grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .team-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .vision-content {
    flex-direction: column;
    gap: 40px;
  }

  .vision-image {
    flex: 1;
    width: 100%;
    transform: none; /* cancel desktop transform on smaller screens */
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 20px;
  }

  .hero-title {
    font-size: 28px;
  }

  .quote-text {
    font-size: 32px;
  }

  .team-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .choose-image {
    width: 100%;
    height: auto;
  }

  .choose-number {
    font-size: 120px;
  }

  /* Make solution image fully fluid on phones */
  .solution-image {
    height: auto;
    text-align: center;
  }

  .solution-image img {
    width: 100%;
    height: auto;
    min-width: 0;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }

  .vision-image {
    transform: none;
    width: 100%;
  }
}
</style>